import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ['input'] }],
      // Every custom boxShadow key must be listed: an unregistered key is
      // invisible to twMerge, so it cannot displace `shadow-none`.
      shadow: [{ shadow: ['soft', 'field', 'event-card', 'lift'] }],
      'border-w': [{ border: ['thin'] }],
      // Unregistered, twMerge reads `text-nav` as a colour, so
      // `cn('text-nav', 'text-off-black')` silently drops the size.
      'font-size': [{ text: ['nav'] }],
      // Custom named widths from tailwind.config.js so twMerge dedupes them
      // against default width utilities like w-full.
      w: [{ w: ['preview-image', 'edit-image', 'preview-field', 'config-col', 'config-container', 'confirm-dialog', 'status-badge'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
